/* eslint-disable camelcase */
import request from '@/utils/request'

export function validateLink (p_query) {
  return request({
    url: '/fooma/validate/' + p_query.document_id + '/' + p_query.expiration,
    method: 'get'
  })
}

// Login s rodnym cislom (pin) pre 
export function authLink (p_query) {
  return request({
    url: '/fooma/auth/' + p_query.document_id + '/' + p_query.expiration + '/' + p_query.pin,
    method: 'get'
  })
}

export function trackSignClick (p_document_id) {
  return request({
    url: '/fooma/track/' + p_document_id,
    method: 'get'
  })
}

export function signDocument (p_document_id, p_signature, p_headers) {
  return request({
    headers: p_headers,
    url: '/fooma/sign/' + p_document_id,
    method: 'put',
    data: p_signature
  })
}



// WEBPACK FOOTER //
// ./src/api/fooma.js